import { Component, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';
import packageJson from '../../../../../package.json';

import { HeaderService } from '../../services/header/header.service';
import { DLSRouteStateService, DLSRouteState } from '../../../core/services/dls-route-state/dls-route-state.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { DOCUMENT } from '@angular/common';

declare type ThemeType = 'light' | 'dark';

@Component({
  selector: 'dls-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private basePath: string;

  public version: string = packageJson.version;
  public heading: string;
  public toggle: DLSRouteState;
  public noToggle: boolean;
  public isToggleDisabled: boolean;
  public pageTabs: { tabName: string, fullPath: string }[];
  public hideHeader: boolean;
  public theme: ThemeType;
  public headerMobileSource: string;
  public headerTabletSource: string;

  @Input()
  sideNav: MatSidenav;

  constructor(
    private _router: Router,
    private _headerService: HeaderService,
    private _dlsRouteState: DLSRouteStateService,
    @Inject(DOCUMENT) private _document: Document,
  ) {
    this.heading = '';
    this.toggle = null;
    this.noToggle = false;
    this.isToggleDisabled = false;
    this.pageTabs = [];
    this.basePath = '/';
    this.theme = 'light';

    this._headerService
      .valueChanges$
      .subscribe((value) => {
        this.toggle = this._dlsRouteState.state;
        this.setHeaderServiceValues(value);
      });
    this.toggleTheme(this.theme);
  }

  // To set the header service values
  private setHeaderServiceValues(value: { [k: string]: any }): void {
    this.heading = value['heading'];
    this.noToggle = value['isDesign'] === null && value['isDevelop'] === null;
    this.isToggleDisabled = !(value['isDesign'] && value['isDevelop']);
    this.pageTabs = value['pageTabs'] || [];
    this.basePath = value['basePath'];
    this.hideHeader = value['hideHeader'];
  }

  /**
   * To apply the background theme
   * And update the image in the toolbar based on the theme
   * */
  public toggleTheme(value: ThemeType): void {
    if (value === 'dark') {
      this._document.body.classList.add('dark-mode');
      this.headerMobileSource = './assets/images/logos/outline-header-mobile.svg';
      this.headerTabletSource = './assets/images/logos/outline-header-tablet.svg';
      this._headerService.setDarkTheme(true);
    } else {
      this._document.body.classList.remove('dark-mode');
      this.headerMobileSource = './assets/images/logos/header-mobile.svg';
      this.headerTabletSource = './assets/images/logos/header-tablet.svg';
      this._headerService.setDarkTheme(false);
    }
  }


  public toggleChange(event: MatButtonToggleChange) {
    // Update DLS route state
    this._dlsRouteState.state = event.value;

    // Navigate
    this._router.navigateByUrl(`${this.basePath}/${this._dlsRouteState.state}`);
  }
}
